// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-segment-button {
  font-size: 12px;
  font-weight: 700 !important;
}

ion-content {
  position: absolute !important;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/notification-chat/notification-chat.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,6BAAA;AACF","sourcesContent":["ion-segment-button {\n  font-size: 12px;\n  font-weight: 700 !important;\n}\n\nion-content {\n  position: absolute !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
